import { useAuthFetchWithResponse } from '@e3dc-react/shell/Hooks/AuthFetch'

import { getTariffsMode } from '../api'
import { TariffsModeModel } from '../model'
import { usePortalQuery } from 'src/Libs/api'

type ReturnType = {
  tariffsMode: TariffsModeModel | null
  isLoading: boolean
  refetch: () => void
}

export const useFetchTariffsMode = (installationId: number | undefined): ReturnType => {
  const authFetch = useAuthFetchWithResponse()

  const { data, isLoading, refetch } = usePortalQuery({
    queryKey: ['tariffs', installationId, 'mode'],
    queryFn: () => getTariffsMode(installationId!, authFetch),
    enabled: !!installationId,
    select: result => result,
    refetchOnMount: 'always',
  })

  return {
    tariffsMode: data ?? null,
    isLoading,
    refetch,
  }
}
